// create new react component for TopBar similar to code in src/components/Footer.js

import { Link } from 'react-router-dom';

const TopBar = () => {
    return (
        <div className="clearfix bg-primary p-2">
            <div className="container">
                <p className="text-white text-center mb-0">Got Tax Questions? Speak with a real expert now — call us to unlock your tax savings: <Link to="tel:+12136064143" className="text-white fw-bold d-block d-md-inline">+1 (213) 606-4143</Link></p>
            </div>
        </div>
    );
}

export default TopBar;
